export const selectService = [
    {
        id: "fixed",
        name: "Servicio a precio cerrado",
        selected: false
    },
    {
        id: "showLead",
        name: "Pedir hasta 3 presupuestos sin compromiso",
        selected: false
    },
];

export const selectLead = [
    {
        id: "leadThree",
        name: "Pedir 3 presupuestos sin compromiso",
        selected: false
    },
    {
        id: "leadOne",
        name: "Pedir 1 presupuesto sin compromiso",
        selected: false
    }
];
